
export default {
    "RISCO BAIXO": 0,
    "RISCO MÉDIO BAIXO": 1,
    "RISCO MÉDIO ALTO": 2,
    "RISCO ALTO": 3,
};
